import React from 'react'
import type { ImageProps } from 'cloudinary-react'
import { Image } from 'cloudinary-react'
import { useCloudinary } from '../../providers/CloudinaryProvider'

/**
 * A drop-in replacement for the Image component from Cloudinary that renders null
 * if there is no <CloudinaryProvider />
 */
export default function CloudinaryImage(props: ImageProps) {
  const { cloudName } = useCloudinary()

  if (!cloudName) {
    return null
  }

  return <Image {...props} />
}
